import React, { useCallback, useState, useContext, useEffect } from 'react';
import _ from 'lodash';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react'
import { MLRewriteService } from 'ml-capability-rewrite';
import { MLOfferingService } from 'gw-capability-gateway';
import { DateUtil, LocalDateUtil } from '@xengage/gw-portals-util-js';
import { MLErrorMessageUtil } from 'ml-portals-util-js';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import appConfig from 'app-config';
import { Identify  } from "gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent";
import Rewrite from '../../model/Rewrite';

import useCheckRewriteSteps from '../../util/useCheckRewriteSteps';
import metadata from './MLRewriteEffectiveDatePage.metadata.json5';

import messages from './MLRewriteEffectiveDatePage.messages';
import styles from './MLRewriteEffectiveDatePage.module.scss'
import { ScrollToError } from '@jutro/legacy/wizard-next';

import { IntlContext } from '@jutro/legacy/locale';

function MLRewriteEffectiveDatePage(props) {
    const {
        updateWizardData, wizardData, goNext, currentStep
    } = props;
    const { submissionVM } = wizardData;
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { UserService } = useDependencies('UserService');
    const [showErrors, updateShowErrors] = useState(false);
    const { isComponentValid, onValidate } = useValidation('rewriteEffectiveDate');
    const checkRewriteSteps = useCheckRewriteSteps();
    const [listOfRewriteReasons, updateListOfRewriteReasons] = useState(submissionVM.reasonForRewrite.aspects.availableValues)
    const [calculatingExpirationDate, updateCalculatingExpirationDate] = useState(false);
    const [availableOfferings, updateAvailableOfferings] = useState([])
    const [isGCS, updateIsGCS] = useState(false);
    const [expirationDateOptionToDate, updateExpirationDateOptionToDate] = useState({
        'maintain_original_expiration_date': submissionVM.originalExpirationDate.value,
        'new_expiration_date': null
    })
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const isGPA = appConfig.portalCode === 'GPA';

    const ModalService = MLModalService();
    const AlertService = MLNotificationBlockUtil();
    const NEW_EXPIRATION_DATE = 'new_expiration_date';

    const checkRewriteLapse = () => {
        const cancellationDateCompare = DateUtil.compareIgnoreTime(DateUtil.currentDate(), LocalDateUtil.toMidnightDate(submissionVM.cancellationEffectiveDate.value))
        return (submissionVM.value.policyFlatCancelled || cancellationDateCompare !== 1);
    };

    useEffect(() => {
        Identify('Rewrite Step Reached', {step: 'Effective Date Screen'}, submissionVM, authHeader)
    }, [])

    useEffect(() => {
        let _listOfRewriteReasons;
        if (submissionVM.value.isPersonalUmbrella() || submissionVM.value.isLandlordHome() || submissionVM.value.isLandlordCondo() || submissionVM.value.policy.latestPeriod.isModernProduct_Ext) {
            _listOfRewriteReasons = submissionVM.reasonForRewrite.aspects.availableValues.filter((item) => item.code !== 'change_offering');
        } else {
            _listOfRewriteReasons = submissionVM.reasonForRewrite.aspects.availableValues;
        }
        if (checkRewriteLapse()) {
            _listOfRewriteReasons = _listOfRewriteReasons.filter((item) => item.code !== 'rewrite_lapse_cov');
        }

        _listOfRewriteReasons = _listOfRewriteReasons.map((reason) => {
            return {
                code: reason.code,
                name: translator({id: reason.name, defaultMessage: reason.name})
            }
        });
        let productCode = submissionVM.policy.product.publicID.value;
        if (submissionVM.value.isHomeOwners()) {
            productCode = submissionVM.value.policy.latestPeriod.lobs_ML.homeowners.coveragePartType_ML;
        }
        updateListOfRewriteReasons([..._listOfRewriteReasons])
        UserService.getCurrentUser(authHeader).then((user) => {
            const MLOfferingServiceInstance = MLOfferingService()
            updateIsGCS(user.isGCSSales || user.isGCSServicing);
            if(submissionVM.value.policy.latestPeriod.isModernProduct_Ext){
                const _availableOfferings = MLOfferingServiceInstance.getAvailableOfferingsForProduct('PersonalAuto_ModernProduct');
                updateAvailableOfferings(_availableOfferings);
            }
            else{
            MLOfferingServiceInstance.refreshOfferingsWithUserType(user.userType);
            const currentPolicyOffering = submissionVM.value.policy.latestPeriod.offering_ML;   
            const _availableOfferings = MLOfferingServiceInstance.getAvailableOfferingsForProduct(productCode).filter((offering) => offering.name !== currentPolicyOffering);
            updateAvailableOfferings(_availableOfferings);
            }
        });
         
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isGPA) {
            PolChangeTrackEvent('Rewrite Step Reached', false, submissionVM, authHeader, { step: 'PolChange Rewrite Effective Date Screen' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        AlertService.clearAlerts();
        if (_.get(submissionVM, 'reasonForRewrite.value.code') === 'other') {
            if (isGCS) {
                AlertService.addErrorAlert(messages.errorMessageGCS, 'GCScontactUsMessage');
            } else {
                AlertService.addErrorAlert(messages.errorMessage, 'contactUsMessage');
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submissionVM.reasonForRewrite.value]);

    const isExpirationDateVisible = () => {
        return !submissionVM.value.policyFlatCancelled && (submissionVM.value.isEffectiveDateChange() || expirationDateOptionToDate[NEW_EXPIRATION_DATE] === null);
    };

    const isExpirationDateVisible2 = (newSubmissionVM) => {
        return !newSubmissionVM.value.policyFlatCancelled && (newSubmissionVM.value.isEffectiveDateChange() || expirationDateOptionToDate[NEW_EXPIRATION_DATE] === null);
    };

    const computeNewTermExpirationDate = (newSubmissionVM) => {
        if (!calculatingExpirationDate && isExpirationDateVisible2(newSubmissionVM)) {
            updateCalculatingExpirationDate(true);
            const expirationDatePromise = MLRewriteService.computeNewTermExpirationDate(
                newSubmissionVM.policy.policyNumber.value,
                newSubmissionVM.effectiveDate.value,
                authHeader
            );
            expirationDatePromise
                .then((newExpirationDate) => {
                    const _expirationDateOptionToDate = {...expirationDateOptionToDate}
                    _expirationDateOptionToDate[NEW_EXPIRATION_DATE] = newExpirationDate;
                    updateExpirationDateOptionToDate(_expirationDateOptionToDate)
                })
                .finally(() => {
                    updateCalculatingExpirationDate(false);
                });
        }
    }

    const withDate = useCallback((expirationDateOption) => {
        const dateForDateOption = expirationDateOptionToDate[expirationDateOption.code];
        const name = translator({id: expirationDateOption.name, defaultMessage: expirationDateOption.name});
        if (dateForDateOption) {
            const date = LocalDateUtil.toMidnightDate(dateForDateOption);
            const parsedDate = intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' });
            return `${name} (${parsedDate})`;
        }
        return name;
    }, [expirationDateOptionToDate, intl, translator]);

    const getExpirationDateOptions = useCallback(() => {
        return submissionVM.expirationDateOption.aspects.availableValues.map((option) => {
            return {
                code: option.code,
                name: withDate(option)
            }
        })
    }, [submissionVM.expirationDateOption.aspects.availableValues, withDate])

    const onNext = useCallback(() => {
        if (!(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            return;
        }

        submissionVM.value.portalCurrentStep_ML = currentStep.mlStepName
        const promise = MLRewriteService.saveAndQuote(submissionVM.value, authHeader);
        ModalService.showProgressDialog(messages.save, promise);
        promise.then((result) => {
            submissionVM.value = new Rewrite(result);
            updateWizardData(wizardData);

            if (isGPA) {
                PolChangeTrackEvent('Rewrite Step Submitted', false, submissionVM, authHeader, {
                    step: 'PolChange Rewrite Effective Date Screen',
                    action: 'Rewrite Effective Date Submitted'
                });
            }
            
            checkRewriteSteps.checkSteps(submissionVM);
            goNext();
        }).catch((error) => {
            const displayableErrorMsg = MLErrorMessageUtil.retrieveDisplayableErrorMessage(error);
            const modalTitle = translator(messages.saveErrorTitle);
            const modalMessage = displayableErrorMsg || translator(messages.saveErrorMessage);
            ModalService.showErrorModal(modalTitle, modalMessage);
        });
    }, [submissionVM, currentStep.mlStepName, authHeader, ModalService, errorTimestamp, updateWizardData, wizardData, isGPA, checkRewriteSteps, goNext, UserService, translator]);

    const getNextStepText = () => {
        return (
            <>
                {translator(messages.nextDescription, {
                    strong: (chunks) => <strong>{chunks}</strong>
                })}
            </>
        );
    };

    const handleEffectiveDateChange = (value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        wizardData.submissionVM = newSubmissionVM;
        updateWizardData(wizardData);
        computeNewTermExpirationDate(newSubmissionVM)
    };

    const overrideProps = {
        rewriteReason: {
            availableValues: listOfRewriteReasons
        },
        offeringTypeRow: {
            visible: submissionVM.value.isChangeOffering()
        },
        effectiveDateRow: {
            visible: submissionVM.value.isEffectiveDateChange() || submissionVM.value.isChangeOffering()
        },
        offeringType: {
            availableValues: availableOfferings
        },
        effectiveDate: {
            minDate: submissionVM.minEffectiveDate.value,
            onValueChange: handleEffectiveDateChange
        },
        expirationDateRow: {
            visible: isExpirationDateVisible()
        },
        expirationDate: {
            disabled: calculatingExpirationDate,
            availableValues: getExpirationDateOptions()
        },
        throbberLoading: {
            visible: calculatingExpirationDate
        },
        nextButton: {
            disabled: submissionVM.value.isOther()
        },
        nextDescription: {
            content: getNextStepText(),
        },
        transactionRequestedByAgentRow: {
            visible: false
        },
    };

    const handleModelChange = useCallback(
        (newModel) => {
            updateWizardData({
                ...wizardData,
                submissionVM: newModel
            });
        },
        [updateWizardData, wizardData]
    );

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onNext
        }
    }

    return (
        <WizardPage
            showCancel={false}
            showNext={false}
            showPrevious={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={handleModelChange}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                onValidationChange={onValidate}
                showErrors={showErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

export default MLRewriteEffectiveDatePage;